/**
 * @func isArray
 * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
 * @type {Function}
 * @since 3.0.0
 */
module.exports = Array.isArray
